// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__R-WN3","overflowing":"ReadFullNote_overflowing__PVdiN"};